
import React from 'react'
import CommentIcon from '@mui/icons-material/Comment'
import { Badge, Typography } from '@mui/material'
import { DensityStyleTypes } from 'types'

interface CommentCountProps {
  commentCount: number | null
  boardTheme: string
  onClick?: () => void
  densityStyles?: Partial<DensityStyleTypes>
}

const CommentCountIcon: React.FC<CommentCountProps> = ({ commentCount, boardTheme, onClick, densityStyles }) => {
  return (
    <Badge
      badgeContent={
        <Typography
          sx={{
            fontSize: densityStyles?.badgeFontSize ?? 14,
            color: boardTheme,
            fontWeight: 'bold',
          }}
        >
          {!commentCount ? '' : commentCount}
        </Typography>
      }
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '.MuiBadge-badge': {
          minWidth: 16,
          height: 16,
          fontSize: '10px',
          padding: 0,
          transform: 'translate(10px, -10px)', // Moves the badge closer to the icon
        },
      }}
    >
      <CommentIcon
        sx={{
          color: 'text.primary',
          height: densityStyles?.iconSize ?? 38,
          width: densityStyles?.iconSize ?? 38,
        }}
      />
    </Badge>
  )
}

export default CommentCountIcon
